<template>
  <div id="content" class="where_to_innovate_finder">
    <DataRoomModal :dialogVisible='dataroommalodal' @endOfDataroomUpload="closeDataRoomModal($event)"></DataRoomModal>
    <ConfirmModal :dialogVisible='confirmDataroom' @close="confirmDataroom = false" @confirmed="confirmAndGoToSTepOneCB($event)" message="Are you sure you want to continue without uploading consumer or market insights?<br/>These help generate more relevant innovation topics." ></ConfirmModal>
    <ConfirmModal :dialogVisible='confirmDelete' @close="confirmDelete = false" @confirmed="confirmDeleteBrief($event)" message="Are you sure ? This action can't be canceled." ></ConfirmModal>
    <NameModal  :dialogVisible='show_rename_modal' @close="show_rename_modal = false" @newValueIsProposed="renameTheBrief($event)" formName="Rename your innovation topic" :projectName="to_rename_name"></NameModal>

    <div class="ai_loader" v-if="pearlAI_reflexion">
      <div class="ai_loader_in">
        <img :src="require('@/assets/loaderInnopearl.svg')" alt="">
        <div class="ai_loader_text" v-html="ai_loader_text"></div>
      </div>
    </div>
    <div class="content_div">
      <div class="inner ">

        <div class="">
          <div class="subtitle">MY INNOVATION PROJECTS</div>
        </div>

        <div class="bandeau_data_room">
          <div class="buttons_dataroom">
            <button type="button" name="button" class="uploadDocDataRoomButton" @click="dataroommalodal = true"><span>UPLOAD YOUR DOCUMENTS</Span>        <img :src="require('@/assets/uploadArrow.svg')" alt=""></button>
            <button type="button" name="button" class="continueButton" @click="newSearch()"><span>NEW SEARCH</Span>        <img :src="require('@/assets/continueArrow.svg')" alt=""></button>
          </div>
          <a href="/pearlai_dataroom" target="_blank" class="dataroom_size" >
            {{dataroom_size}} DOCUMENT<span v-if='dataroom_size > 1'>S</span> IN DATA ROOM
          </a>

        </div>
      </div>


      <div class="list_of_briefs">
          <div class="list_of_briefs_main_title">
              Briefs for Scouting
          </div>
          <div class="list_of_briefs_actions">


          <div class="sort-selector"  @click="focusSelect">
            <select ref="sortSelect" v-model="sortBy" class="sort-select">
              <option value="">{{$t("Sort by...")}}</option>
              <option value="nameASC">{{$t("Name (A to Z)")}}</option>
              <option value="nameDESC">{{$t("Name (Z to A)")}}</option>
              <option value="deadlineASC">{{$t("Date (Oldest first)")}}</option>
              <option value="deadlineDESC">{{$t("Date (Most recent first)")}}</option>
            </select>
          </div>
        </Div>
        <div class="loaderInnopearl " v-if="loading || loadingm">
          <div class="loaderInnopearlInner">
            <img :src="require('@/assets/loaderInnopearl.svg')" alt="">
            <span>Loading in progress</span>
          </div>

        </div>
          <div class="list_of_briefs_list" v-if="briefs.length > 0">
            <div class="one_brief" v-for="(brief, b) in sortedBrief" :key="b">
              <div class="one_brief_header">
                <div class="brief_date">
                  {{brief.date_creation}}
                </div>
                <button class="brief_delete" @click="deleteBrief(brief._id.$oid)">
                  <img :src="require('@/assets/trashInno.svg')" alt=""/>
                </button>
              </div>
                <div class="brief_challenge">
                    <div class="brief_challenge_title">
                        <span>My innovation topic</span>
                        <button class="topic_name_edit" @click="editTopicName(brief)">
                          <img :src="require('@/assets/editCriteria.svg')" alt=""/>
                        </button>
                    </div>
                    <div class="brief_challenge_value">
                      {{brief.title}}
                    </div>
                </div>
                <div class="brief_action">
                    <a :href="'/where_to_innovate_results/'+brief._id.$oid">FIND INNOVATORS</a>
                </div>
            </div>
          </div>
          <div class="no_brief" v-else>
            <span v-if="!loading && !loadingm">No briefs generated via AI yet</span>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../tools/api';
// // import router from '@/router'
 import DataRoomModal from '@/components/DataRoomModal.vue'
 import NameModal from '@/components/modals/projectNameModal.vue'

 import ConfirmModal from '@/components/modals/ConfirmModal.vue'
//  //
import { toast } from 'vue-sonner'
export default {
  components: {
DataRoomModal,
ConfirmModal,
NameModal
  },
  name: 'WhereToInnovateFinder',
  data() {
    return {
      pageInfo: {
        mainTitle : "Targeting",
        subTitle : "My AI-powered briefs",
      },
      loading:false,
      sortBy:"",
      dataroommalodal:false,
      ai_loader_text : "Please wait while PearlAI ​​analyzes the data.",
      pearlAI_reflexion:false,
      apiUrl: process.env.VUE_APP_API_URL,
      sessionId : null,
      prompt : "",
      dataroom_size:0,
      needs_prompt:false,
      first_message : true,
      userInfo:null,
      selectedTopic : null,
      messages : [],
      step:-1,
      loadingm:false,
      confirmDataroom:false,
      brief_for_delete:null,
      briefs: [],
      confirmDelete : false,
      show_rename_modal:false,
      to_rename_name:"",
      brief_to_rename: null,
    }
  },
  methods:{
    focusSelect() {
      this.$refs.sortSelect?.focus();
    },
    editTopicName(brief){
      this.brief_to_rename = brief;
      this.to_rename_name= brief.title;
      this.show_rename_modal = true;
    },
    renameTheBrief(v){

      if(v != this.to_rename_name){
        api.post(process.env.VUE_APP_API_URL+"/restrict/rename_pearlai_brief",
            {
              brief : this.brief_to_rename._id.$oid,
              newname : v
            },
            {
              headers: {
                  'Content-Type': 'application/json',
            }
          }).then( () => {
            toast.success("Brief successfully renamed.");
            this.getAIBrief();
          });
      }
      this.show_rename_modal = false;
      this.brief_to_rename = null;
      this.to_rename_name = "";
    },
    deleteBrief(briefID){
      this.brief_for_delete = briefID;
      this.confirmDelete = true;
    },
    confirmDeleteBrief(v){
      this.confirmDelete = false;
      if(v){
        api.post(process.env.VUE_APP_API_URL+"/restrict/remove_pearlai_brief",
            {
              brief : this.brief_for_delete,
            },
            {
              headers: {
                  'Content-Type': 'application/json',
            }
          }).then( () => {
            toast.success("Brief successfully removed.");
            this.getAIBrief();
          });
      }
      this.brief_for_delete = null;
    },
    parseDate(dateString) {

      if(!dateString)dateString = "01/01/1970";
      const [day, month, year] = dateString.split('/').map(num => parseInt(num, 10));
      return new Date(year, month - 1, day); // month is 0-indexed in JavaScript Date
    },
    closeDataRoomModal(v){
      console.log(v);
      if(v){

        this.dataroom_size = v;
      }
      else if(v === 0){
        this.dataroom_size = v;
      }
      this.dataroommalodal = false;
    },
    newSearch(){
      if(this.dataroom_size == 0){
        this.confirmDataroom = true;
      }
      else{
        this.$router.push('/where_to_innovate_finder')

      }
    },
    confirmAndGoToSTepOneCB(ok){
              this.confirmDataroom = false;
      if(ok){

        this.$router.push('/where_to_innovate_finder')
      }

    },
    getAIBrief(){
      this.loading = true;
      api.get(this.apiUrl+"/restrict/get_my_ai_brief").then( (r) => {
        console.log(r.data);
        this.briefs = r.data;
        this.loading=false;
      }).catch( (e) => {
        console.log(e);
        this.loading=false;
         toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
      });
    },
    reloadDataRoom(){
      this.loading =true;
      api.get(this.apiUrl+"/restrict/get_my_dataroom").then( (r) => {
        this.dataroom_size = r.data.makert_and_business_intelligence_files.length + r.data.priorities_and_goals_files.length;
        console.log(this.dataroom_size);
        if(this.dataroom_size == 0)this.step = 0;
        else this.step = 1;
        console.log(r);
        this.loading=false;
      }).catch( (e) => {
        console.log(e);
        this.loading=false;
         toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
      });
    },
    handleKeyup(event) {
      if (event.key === 'Enter' && !event.ctrlKey && !event.shiftKey && !event.altKey && !event.metaKey) {
        this.sendMessage();
      }
    },

  },
  mounted(){
    this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo);
    this.loadingm = true;
    this.reloadDataRoom();
    this.getAIBrief();
    this.loadingm = false;
    api.get(process.env.VUE_APP_API_URL+"/restrict/myaccount").then( (r) => {
      this.userInfo = r.data;
      this.$store.commit('UPDATE_ROLE',r.data.role);
    }).catch( (e) => {
      console.log(e);
       toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
    });


  },
  computed:{
    sortedBrief() {
    return [...this.briefs].sort((a, b) => {
      switch (this.sortBy) {
        case 'nameASC':
          return a.title.toLowerCase().localeCompare(b.title.toLowerCase());
        case 'nameDESC':
          return (b.title.toLowerCase() || '').localeCompare(a.title.toLowerCase() || '');
        case 'deadlineASC':
          return this.parseDate(a.date_creation) - this.parseDate(b.date_creation);
        case 'deadlineDESC':
          return this.parseDate(b.date_creation) - this.parseDate(a.date_creation);
        default:
          return 0;
      }
    });
  }
  }

}
</script>
<style scoped>

.where_to_innovate_finder{
  padding-top:50px;
  padding-bottom: 50px;
  padding: 50px;
}
.content_div{
  padding: 50px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
display: flex;
  flex-direction: column;
}

.firstmessage{
  margin-top:50px;
}
.title{
  color:#3783C5;
  font-size:24px;
  font-weight: 500;
  text-transform: uppercase;
  font-family: "Inter";
  text-align:center;
}
.subtitle{
  color:#3783C5;
  font-size:20px;
  font-weight: 500;
  font-family: "Inter";
  text-align:center;
}



.ai_loader{
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  background: rgba(0,0,0,.2);
  width: 100%;
  display: block;
  height: 100%;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 50px;
}

.ai_loader_in{
  background: #FFF;
  padding: 20px;
  border-radius: 50px;
  display: flex;
  flex-direction: row;
  gap: 20px;
  justify-content: center;
  align-content: center;
  align-items: center;

}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.ai_loader_in img{
  width:45px;
  animation: rotate 3s linear infinite;
}

.ai_loader_in .ai_loader_text{
  font-size: 18px;
  font-weight: 600;
  color:#04246A;
}

.header.withDataRoom{
  width:100%;
  display:block;
  margin-bottom: 25px;
}
.goToDataroom{
  background: #3783C5;
  color:#FFF;
  padding:10px 20px;
  float:right;
  display:flex;
  align-items: center;
  gap:10px;
  font-size:12px;
  text-transform: uppercase;
  border-radius:50px;
  font-weight: 500;
}

.goToDataroom .dataroom_size{
  background:#115AA4;
  padding:2px;
  border-radius: 50%;
  width:25px;
  height:25px;
  display:flex;
  font-size:12px;
  justify-content: center;
  align-items: center;
}

.actions_on_brief{
  display:flex;
  justify-content: flex-end;
  align-items: flex-end;
  width:100%;
}

.topicsListTitele{
  text-align: center;
  width: 100%;
  display: block;
  font-weight: 600;
  margin-top: 20px;
  color: #04246A;
  font-size: 20px;
}

.footer_message_session_warning{
  text-align: center;
  font-weight: 600;
  font-size: 13px;
  margin-top:50px;
  color: #04246A;

}
.aimode_ttile{
  display:flex;
  align-items:center;
  justify-content:center;
  gap:10px;
}
.aimode{
  font-size: 13px;
  padding:5px 10px;
  color:#B38D2F;
  font-weight:600;
  background:#FFEBB9;
  border-radius:25px;
}


.bandeau_data_room{
  background:#F1F6FC;
  padding:20px;
  border-radius:50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top:50px;
  position:relative;
  flex-wra:wrap;
}
.bandeau_data_room .buttons_dataroom{
  display:flex;
  gap:20px;
flex:1;
justify-content:center;
flex-wra:wrap;
}

.bandeau_data_room .dataroom_size{
position:absolute;
right:50px;
top:50%;
transform:translateY(-50%);
font-size: 13px;
    color: #04246A;
  font-weight:600;
  margin-left:auto;
}
@media screen and (max-width:1500px){
  .bandeau_data_room .dataroom_size{
  position:relative;
  right:auto;
  top:auto;
  transform:none;
  width:100%;
  text-align:center;
  display:block;
  margin-top:20px;
}
.bandeau_data_room{
flex-direction:column;
}
}
@media screen and (max-width:1000px){
.bandeau_data_room .buttons_dataroom{
flex-direction:column;
}
.aimode_ttile{
flex-direction:column-reverse;
}
}
.continueButton{
  background:#FFF;
  border: 1px solid #3783C5;
  border-radius: 25px;
  padding: 7px 20px;
  color: #3783C5;
  display:flex;
  gap:10px;
  justify-content:center;
  align-items:center;
}
.uploadDocDataRoomButton{

display:flex;
gap:10px;
justify-content:center;
align-items:center;
  border: 1px solid #3783C5;
  border-radius: 25px;
  padding: 7px 20px;
  background: #3783C5;
  color: #FFF;
}


.list_of_briefs{
  background:#F1F6FC;
  padding:50px 25px ;
  border-radius:15px;

  margin-top: 50px;
  position: relative;
}
.list_of_briefs_main_title{
  width: 100%;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  color: #04246A;
}

/* Base Styles */
.list_of_briefs_list {
  margin-top:50px;
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 4 columns for desktop */
  gap: 16px; /* Adjust the gap between items */
}

.no_brief{
  margin-top:50px;
  text-align:center;
    color: #04246A;
    font-size:13px;
    font-weight: 600;
}

/* Small Desktop */
@media (max-width: 1300px) {
  .list_of_briefs_list {
    grid-template-columns: repeat(3, 1fr); /* 3 columns for small desktop */
  }
}

/* Tablet */
@media (max-width: 990px) {
  .list_of_briefs_list {
    grid-template-columns: repeat(2, 1fr); /* 2 columns for tablet */
  }
}

/* Mobile */
@media (max-width: 690px) {
  .list_of_briefs_list {
    grid-template-columns: 1fr; /* 1 column for mobile */
  }
}
.one_brief{
  background:#FFF;
  padding:20px;
  border-radius:10px;
  display:flex;
  flex-direction: column;
  gap:20px;
}

.one_brief .one_brief_header{
  display:flex;
  justify-content: space-between;
  align-items: center;

}

.one_brief .one_brief_header .brief_date{
  color:#3783C5;
  font-size:13px;
}

.one_brief .brief_challenge{
  display:flex;
  flex-direction: column;
  margin-bottom:30px;
}
.brief_challenge_title{
  color:#04246A;
  font-size:15px;
  font-weight: 600;
  display:flex;
  gap:5px;
  align-items:center;
}
.brief_challenge_value{
  color:#04246A;
  font-size:15px;
}

.brief_action a{
  width:100%;
  padding:10px;
  border:1px solid #3783C5;
  color:#3783C5;
  font-size:13px;
  text-transform: uppercase;
  text-align:center;
  border-radius:50px;
  display:block;
}
.brief_action{
  margin-top:auto;
}

@media screen and (max-width:990px){
  .where_to_innovate_finder{
    padding-left:10px;
    padding-right:10px;
  }
  .where_to_innovate_finder .content_div{
    padding-left:20px;
    padding-right: 20px;
  }
}


.list_of_briefs_actions{
  display: flex;
    width: 100%;
    justify-content: flex-end;
    margin-top:20px;
    margin-bottom: 20px;
}
.list_of_briefs_actions .sort-select{
  background:#FFF;
  padding: 5px 10px;
  padding-right:30px;
  border: 1px solid #D1E8FB;
  color:#3783C5;
  border-radius: 20px;
  z-index:10;
}
.list_of_briefs_actions .sort-selector{
  position:relative;
  display:inline-block;


}
.list_of_briefs_actions .sort-selector::after{
  position:absolute;
  top: 8px;
  right:10px;
  content:  url('@/assets/orderbyblue.svg');
  z-index:0;
   pointer-events: none;
}
</style>
